module.exports = __webpack_public_path__ + "media/images/arrows/bullet-green-aa2b938021eea990ea36e8692c59a365.svg";